<ion-toolbar class="lg:hidden mobile-menu-container" [ngClass]="menuGradientActive ? 'mobile-menu-container-gradiant' : 'mobile-menu-container'">
	<ion-grid class="p-0">
		<ion-row class="text-xxs text-white text-center "  [ngClass]="{ 'ios-safe-area-bottom': platformIsIOS }">
			<ion-col
				*ngFor="let menu of array_menu4"
				(click)="!networkIsActive && (
          (menu.path !== 'cursos' && menu.path !== 'lista-checklists')
          || (menu.path === 'lista-checklists' && !hasChecklistOffline) ) ? '' : openPage(menu.path)"
				class="py-1 flex flex-col items-center justify-around text-white ion-activatable ripple-parent"
				[ngClass]="{
					'page-selected': select_page == menu.path,
					'opacity-50': !networkIsActive && (
            (menu.path !== 'cursos' && menu.path !== 'lista-checklists')
            || (menu.path === 'lista-checklists' && !hasChecklistOffline) )
				}"
			>
				<ion-ripple-effect></ion-ripple-effect>
        <div class="flex flex-col gap-[3px] justify-center items-center">
          <ion-icon [src]="select_page == menu.path ? menu.selectedIcon : menu.icon" class="text-xl align-text-center  w-full"></ion-icon>
          <span>{{ menu.name }}</span>
        </div>
        <div [ngClass]="getBarClass(menu.path)" class="w-11/12 rounded-md h-[4px] bg-white"></div>
			</ion-col>
			<!-- open side menu-->
			<ion-col (click)="openSideBarMobile()"
				class="py-1 text-white flex flex-col items-center justify-center border-b-6 border-solid border-transparent  ion-activatable ripple-parent "
			>
			  <ion-ripple-effect></ion-ripple-effect>
				<div class="rounded-full h-5 w-5  border-1 border-white flex justify-center items-center mb-1.5 box-content bg-white">
					<img *ngIf="data_empresa" class="w-5 h-5 rounded-full" [src]="data_empresa.app_main_isotipo || '../../../assets/icon/favicon.png' ">
				</div>
				<span>{{language === 'es' ? 'Menú' : 'Menu'}}</span>
				<!-- <span>{{ iniciales || "" }}</span> -->
				<div *ngIf="new_notification" class="flex w-3 h-3 absolute right-4 top-3">
					<div class="relative">
						<div class="w-3 h-3 bg-red-500 rounded-full"></div>
						<span
							class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75 top-0 left-0"
						></span>
					</div>
				</div>
        <span *ngIf="userplatformVersion" class="absolute bottom-[-2px] right-1 opacity-30 text-[7px]">{{userplatformVersion}}</span>

			</ion-col>
		</ion-row>
	</ion-grid>
</ion-toolbar>
